import { CLEAR_DATA_SETS, GET_DATA_SETS_WITH_PAGINATION, SEARCH_DATA_SETS, UPDATE_ALL_DATA_SETS, UPDATE_DATA_SET } from '../types/dataSetsTypes';

import initialState from '../../store/initialState';
import { ACCOUNT_LOGOUT } from '../types/accountTypes';

const dataSetsReducer = function (state = initialState.dataSet, action) {
  switch (action.type) {
    case GET_DATA_SETS_WITH_PAGINATION:
      return {
        ...state,
        dataSets: action.payload.dataSets,
        pageNumber: action.payload.pageNumber,
        totalCount: action.payload.totalCount,
        pageSize: action.payload.pageSize || state.pageSize,
      };
    case SEARCH_DATA_SETS:
      return {
        ...state,
        dataSets: action.payload.dataSets,
        pageNumber: action.payload.pageNumber,
        totalCount: action.payload.totalCount,
      };
    case UPDATE_DATA_SET:
      return {
        ...state,
        dataSets: state.dataSets.map((d) =>
          d.clientId === action.payload.clientId && d.contractId === action.payload.contractId ? action.payload : d,
        ),
      };
    case UPDATE_ALL_DATA_SETS:
      return {
        ...state,
        dataSets: action.payload,
      };

    case CLEAR_DATA_SETS:
    case ACCOUNT_LOGOUT:
      return {
        ...initialState.dataSet,
      };
    default:
      return state;
  }
};

export default dataSetsReducer;
